import { useState, useEffect } from "react";
import PageHeader from "../../components/pageHeader";
import { API_BASE } from "../../config/apiConfig";
import { useToast } from "../../hooks/useToast";
import MainContentLayout from "../../components/mainContentLayout";
import LoadingOverlay from "../../components/loadingOverlay";

export default function HolidaysAdmin() {
  const token = sessionStorage.getItem("access_token");
  const { showToast, ToastContainer } = useToast();

  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const years = Array.from({ length: 6 }, (_, i) => now.getFullYear() + i);

  const [loading, setLoading] = useState(false);
  const [holidays, setHolidays] = useState([]);

  // Load holidays
  useEffect(() => {
    fetchHolidays();
  }, [year]);

  async function fetchHolidays() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/holidays/list?year=${year}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();

      if (data.success) {
        setHolidays(data.items);
      } else {
        showToast(data.message || "Failed to load holidays", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to load holidays", "error");
    } finally {
      setLoading(false);
    }
  }

  // Import holidays
  async function handleImport() {
    if (!window.confirm(`Import holidays for year ${year}?`)) return;

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/holidays/import`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ year })
      });

      const data = await res.json();

      if (data.success) {
        showToast(`${data.message}`, "success");
        fetchHolidays();
      } else {
        showToast(data.message || "Import failed", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Import failed", "error");
    }
    setLoading(false);
  }

  return (
    <MainContentLayout>
      <PageHeader title="Public Holidays" backTo="/dashboard" />

      {/* Year selector + Import button */}
      <div className="flex items-center gap-4 mb-6">
        <select
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}
          className="border rounded px-3 py-2"
        >
          {years.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>

        <button
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          onClick={handleImport}
          disabled={loading}
        >
          {loading ? "Importing..." : "Import Holidays"}
        </button>
      </div>

      {/* Holiday table */}
      {holidays.length === 0 ? (
        <p className="text-gray-500">No holidays for this year.</p>
      ) : (
        <table className="w-full border text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">Date</th>
              <th className="p-2 border">Holiday Name</th>
            </tr>
          </thead>
          <tbody>
            {holidays.map((h) => (
              <tr key={h.id}>
                <td className="p-2 border">{h.id}</td>
                <td className="p-2 border">{h.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <ToastContainer />
      <LoadingOverlay show={loading} />
    </MainContentLayout>
  );
}
